<template>
  <v-row>
    <v-col cols="12">
      <v-card class="app-card">
        <v-card-title>
          <span class="title">Services List</span>
        </v-card-title>
        <v-card-text>
          <p>This is the list of services for which <b>{{ accountDetails.email }}</b> has an access.</p>
          <v-data-table :headers="headers"
                        :items="accountServices">
            <template v-slot:item.name="{ item }">
              {{ item.name }}
            </template>
            <template v-slot:item.groupname="{ item }">
              {{ item.groupname }}
            </template>
            <template v-slot:item.domain="{ item }">
              {{ item.domain }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ProfileAccessManage',
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data () {
    return {
      headers: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Group',
          value: 'groupname',
        },
        {
          text: 'Domain',
          value: 'domain',
        }
      ],
    }
  },
  computed: {
    ...mapGetters(['accessApprovedList', 'services']),
    accountDetails () {
      return this.accessApprovedList.find(el => el.id == this.id)
    },
    accountServices () {
      if (!this.accountDetails) {
        return []
      }
      return this.services.filter(service => this.accountDetails.services.indexOf(service.id) !== -1)
    }
  }
}
</script>
